// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIdSourceTypeDto
 */
export interface IIdSourceTypeDto {
    /**
     * 
     * @type {number}
     * @memberof IIdSourceTypeDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IIdSourceTypeDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IIdSourceTypeDto
     */
    description?: string;
}

/**
 * Check if a given object implements the IIdSourceTypeDto interface.
 */
export function instanceOfIIdSourceTypeDto(value: object): value is IIdSourceTypeDto {
    return true;
}

export function IIdSourceTypeDtoFromJSON(json: any): IIdSourceTypeDto {
    return IIdSourceTypeDtoFromJSONTyped(json, false);
}

export function IIdSourceTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIdSourceTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function IIdSourceTypeDtoToJSON(json: any): IIdSourceTypeDto {
    return IIdSourceTypeDtoToJSONTyped(json, false);
}

export function IIdSourceTypeDtoToJSONTyped(value?: IIdSourceTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
    };
}

